<template>
  <div class="tab-content">

    <LoadingIcon
      v-if="!pollSelectedProjects || pollSelectedProjects.length === 0"
    />
    <v-component :is="table"
      v-else-if="pollSelectedProjects.length > 0"
      :type="pollType"
      :projects="selectedProjects"
      :tags="projectTags"
    />

  </div>
</template>


<script>
import LoadingIcon from '@/components/utils/LoadingIcon';
import opportunityTable from '@/components/project/OpportunityProjectTable';
import monitorTable from '@/components/project/MonitorProjectTable';

import { mapState, mapActions } from 'vuex';

import { getBRDateTime } from '@/utils/DateUtils';

export default {
  name: 'PollManageProject',
  components: { LoadingIcon },
  props: [],
  created() {
    if( !this.$route.params.id ) return
    
    this.$store.dispatch( 'fetchProjectSources', {
      sourceType: this.pollManage.sourceOfProjects
    })
    this.$store.dispatch( 'getManagementProjects', {
      pollId: this.$route.params.id
    })
  },
  data: () => ({
  }),
  computed: {
    ...mapState([ 'pollManage', 'pollSelectedProjects', 'projectSources' ]),
    pollType: function() {
      return this.pollManage ? this.pollManage.pageType : ''
    },
    selectedProjects: function() {
      if( !this.pollSelectedProjects || this.pollSelectedProjects.length === 0 )
        return
      
      const projects = this.pollSelectedProjects.map( project => {
        let p = project;
        p.lastDateVoteAt = project.lastDateVoteAt ? getBRDateTime( project.lastDateVoteAt ) : ''
        return p;
      })
      return projects
    },
    selectedContestId: function() {
      return this.pollManage ? this.pollManage.selectedContestId : undefined
    },
    projectTags: function() {
      if( !this.selectedContestId ) return undefined;
      if( !this.projectSources || this.projectSources.length === 0 ) return undefined;

      const projectSourceObj = this.projectSources.filter( source => source.id === this.selectedContestId )
      if( !projectSourceObj || projectSourceObj.length === 0 )
        return undefined;
      return projectSourceObj[0].tags ? projectSourceObj[0].tags : null;
    },
    table: function() {
      if( !this.pollManage )
        return undefined
      const source = this.pollManage.sourceOfProjects;
      return source === 'OPPORTUNITY' ? opportunityTable : monitorTable
    }
  },
  methods: {
    ...mapActions([ 'fetchSelectedProjects', 'fetchProjectSources' ])
  }
};
</script>


// WEBPACK FOOTER //
// src/components/poll/manage/Project.vue